export class FeedbackData {
    rate: number;
    comment: string;
    screenshot: any;
}
